import { ApiText } from '@classes/api-text';
import { Organism } from '@classes/organism/organism';
import { Region } from '@classes/region';

export class Grouping {
    code?: string;
    createdBy?: string;
    isPublic: boolean;

    text: ApiText;
    region?: Region;

    organisms: Organism[];

    constructor() {
        this.text = new ApiText("");
        this.organisms = [];
    }
}
